import type { GeneralID } from '@types';

export const SMDndType = {
  scenes: Symbol('scenes'),
  category: Symbol('category'),
  subCategory: Symbol('subCategory'),
};

export type DragItemScenes = {
  ids: { id: GeneralID; parentId: number }[];
  includeSelected: boolean;
};

export type DragItemCategory = {
  id: number;
  index: number;
  parentId: number;
};

export type DragItemSubCategory = {
  id: number;
  index: number;
  parentId: number;
};

export type SMDragItem =
  | DragItemScenes
  | DragItemCategory
  | DragItemSubCategory;

type ItemType = string | symbol | null;

export const isScenesItem = (
  item: SMDragItem,
  type: ItemType
): item is DragItemScenes => {
  return type === SMDndType.scenes;
};

export const isCategoryItem = (
  item: SMDragItem,
  type: ItemType
): item is DragItemCategory => {
  return type === SMDndType.category;
};

export const isSubCategoryItem = (
  item: SMDragItem,
  type: ItemType
): item is DragItemSubCategory => {
  return type === SMDndType.subCategory;
};
